import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumEmailContext implements BaseEnumType {
  private static allValues: EnumEmailContext[] = []; // make sure this is top-most
  
  public static unknown = new EnumEmailContext(0, "Unknown", "enum_email_context_unknown");
  public static invoice = new EnumEmailContext(1, "Invoice", "enum_email_context_invoice");
  public static purchaseOrder = new EnumEmailContext(2, "PurchaseOrder", "enum_email_context_purchase_order");
  public static passwordReset = new EnumEmailContext(3, "PasswordReset", "enum_email_context_password_reset");
  public static despatchNote = new EnumEmailContext(4, "DespatchNote", "enum_email_context_despatch_note");
  public static userFeedback = new EnumEmailContext(5, "UserFeedback", "enum_email_context_user_feedback");
  public static creditNote = new EnumEmailContext(6, "CreditNote", "enum_email_context_credit_note");
  public static userInvitation = new EnumEmailContext(7, "UserInvitation", "enum_email_context_user_invitation");
  public static despatchNotification = new EnumEmailContext(8, "DespatchNotification", "enum_email_context_despatch_notification");
  public static taskNotification = new EnumEmailContext(9, "TaskNotification", "enum_email_context_task_notification");
  public static outletPriceList = new EnumEmailContext(10, "OutletPriceList", "enum_email_context_outlet_price_list");
  public static labelOrder = new EnumEmailContext(11, "LabelOrder", "enum_email_context_label_order");
  public static proFormaInvoice = new EnumEmailContext(12, "ProFormaInvoice", "enum_email_context_pro_forma_invoice");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEmailContext.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumEmailContext.unknown; }
  public isInvoice() { return this === EnumEmailContext.invoice; }
  public isPurchaseOrder() { return this === EnumEmailContext.purchaseOrder; }
  public isPasswordReset() { return this === EnumEmailContext.passwordReset; }
  public isDespatchNote() { return this === EnumEmailContext.despatchNote; }
  public isUserFeedback() { return this === EnumEmailContext.userFeedback; }
  public isCreditNote() { return this === EnumEmailContext.creditNote; }
  public isUserInvitation() { return this === EnumEmailContext.userInvitation; }
  public isDespatchNotification() { return this === EnumEmailContext.despatchNotification; }
  public isTaskNotification() { return this === EnumEmailContext.taskNotification; }
  public isOutletPriceList() { return this === EnumEmailContext.outletPriceList; }
  public isLabelOrder() { return this === EnumEmailContext.labelOrder; }
  public isProFormaInvoice() { return this === EnumEmailContext.proFormaInvoice; }

  public static getValues(): readonly EnumEmailContext[] {
    return EnumEmailContext.allValues;
  }

  public static getValuesExcept0(): readonly EnumEmailContext[] {
    return EnumEmailContext.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEmailContext {
    const found = EnumEmailContext.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEmailContext - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEmailContext): EnumEmailContext {
    const found = name ? EnumEmailContext.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEmailContext - Value not found: ${ name }`);
    }

    return found;
  }
}